import { useParams } from "react-router-dom";

import TagIcon from "@/assets/icons/tag.svg";
import NotFound from "@/containers/StatusPages/NotFound";

const Tag404 = () => {
  const { slug } = useParams<{ slug?: string }>();
  return (
    <NotFound
      icon={TagIcon}
      title={L.STATUS_PAGE_TAG_NOT_FOUND_TITLE.replace("{}", slug || "")}
    />
  );
};

export default Tag404;
